module.exports = __webpack_public_path__ + "img/loading.f38207b7.gif";